import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useUpdateAtom } from 'jotai/utils';
import { findDuplicatesAtom } from 'src/shared/dashboardFilters';
import { selectedAssetsAtom } from 'src/shared/selectedAssets';

/**
 * "Find duplicates" action shared by the asset page and the card / row menus.
 *
 * Switches the assets page into duplicates mode for the given asset (exact
 * copies, same file checksum) and goes there. The selection is cleared so a
 * bulk action can't pick up assets the user selected on another page.
 */
export function useFindDuplicates(): (asset: { id: string; name?: string }) => void {
  const history = useHistory();
  const findDuplicates = useUpdateAtom(findDuplicatesAtom);
  const setSelectedAssets = useUpdateAtom(selectedAssetsAtom);

  return useCallback(
    ({ id, name }) => {
      findDuplicates({ id, name: name ?? '' });
      setSelectedAssets([]);
      if (history.location.pathname !== '/assets') history.push('/assets');
    },
    [history, findDuplicates, setSelectedAssets],
  );
}

export default useFindDuplicates;
